import * as React from "react";
import { Button} from "antd";
import { connect } from "react-redux";
//import { CopyToClipboard } from "react-copy-to-clipboard";
import copy from 'copy-to-clipboard';


interface ICheckProps {
  id:any;
  skuName:any;
  createLink:any;
  data:any;
}

// 确认函
class Check extends React.Component<ICheckProps, any> {
  state = {
    data:'',
  };
  constructor(props: ICheckProps) {
    super(props);
  }

  replaceBlank= (oldStr) =>{
    var reg = /\n(\n)*( )*(\n)*\n/g;
    var newStr = oldStr.replace(reg,"\n");
    return newStr;
  }

  show = () => {
    let content = `陛下，请您核对一下订单的所有信息，如有问题请尽快联系我们！
    预定项目:${this.props.skuName}
    ${this.props.data[1] ? '数量：'+this.props.data[1] : ''}
    ${this.props.data[3] ? '成人：'+this.props.data[3] : ''}
    ${this.props.data[4] ? '儿童：'+this.props.data[4] : ''}
    ${this.props.data[6] ? '婴儿：'+this.props.data[6] : ''}
    出发日期:${this.props.data[12]}
    联系人姓名:${this.props.data[2]}
    联系人拼音:${this.props.data[5][0] ? this.props.data[5][0]+' '+this.props.data[5][1] : ''}
    国内手机号(+86):${this.props.data[9]}
    邮箱地址:${this.props.data[15]}    
    `;
    copy(content.replace(/(\n[\s\t]*\r*\n)/g, '\n').replace(/^[\n\r\n\t]*|[\n\r\n\t]*$/g, '')); 
    window.open("https://amos.alicdn.com/getcid.aw?spm=2013.1.0.0.639ea0fdpRotk0&v=3&groupid=0&s=1&charset=utf-8&uid=yl0824&site=cntaobao&fromid=cntaobao");
  }

  render() {
    return (
      <React.Fragment>
      <Button onClick={this.show.bind(this,this.props.id)}>核对信息</Button> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  skuName: state.orderDetails.skuName,
  data: state.orderDetails.data,
});

const mapDispatch = dispatch => {
  return {
    createLink: dispatch.orderDetails.createlink
  };
};

export default connect(
  mapState,
  mapDispatch
)(Check);
